<template>
    <div>
        <f-header
            :locale="locale"
            :is-transparent="true" />
        <div class="l-container--relative">
            <f-status-banner />
        </div>
        <f-footer :locale="locale" />
        <cookie-banner
            data-cookie-anchor
            :locale="locale" />
    </div>
</template>

<script>
import fHeader from '@justeat/f-header';
import '@justeat/f-header/dist/f-header.css';

import fFooter from '@justeat/f-footer';
import '@justeat/f-footer/dist/f-footer.css';

import fStatusBanner from '@justeat/f-status-banner';
import '@justeat/f-status-banner/dist/f-status-banner.css';
import '@justeat/f-searchbox/dist/f-searchbox.css';

import CookieBanner from '@justeat/f-cookie-banner';
import '@justeat/f-cookie-banner/dist/f-cookie-banner.css';

const html = document.querySelector('html');

export default {
    components: {
        fHeader,
        fFooter,
        fStatusBanner,
        CookieBanner
    },
    data () {
        return {
            locale: html && html.getAttribute('lang')
        };
    }
};
</script>

<style lang="scss">
@use "./styles/App.scss";
</style>
